import React, { Component } from 'react';

class ChangePlan extends Component {
  shouldComponentUpdate = () => false;

  render() {
    return (
      <div className="thumbnail recent-properties-box">
        <div className="caption detail">
          <header className="clearfix">
            <div className="pull-left">
              <h1 className="title">
                Suscríbete
              </h1>
            </div>
          </header>
          <h3 className="location">
            <a href="">
              ¿Quieres sacar más provecho de Escena Digital?
            </a>
          </h3>

          <a href="/plans" target="_blank" className="book-btn">
            <span className="book-btn-l">
              <i className="fa fa-link" />
            </span>
            <span className="book-btn-r">Cambiar mi plan</span>
            <div className="clear" />
          </a>

        </div>
      </div>
    );
  }
}

export default ChangePlan;



// WEBPACK FOOTER //
// ./src/components/ChangePlan/index.js